import { render, staticRenderFns } from "./DependentTableView.vue?vue&type=template&id=2d6fc82b&scoped=true"
import script from "./DependentTableView.vue?vue&type=script&lang=ts"
export * from "./DependentTableView.vue?vue&type=script&lang=ts"
import style0 from "./DependentTableView.vue?vue&type=style&index=0&id=2d6fc82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fc82b",
  null
  
)

export default component.exports